import Bloc from './Bloc.js';
import Types from './Types.js';

export default class TurnForward extends Bloc {

	constructor (src, ctx) {

		super("turnforward", src, ctx, true);
		this.f = (src, ins, props) => {

			let player = src.master.player;
			if (player.hasStatus("facing-back")) {
				let statuses = player.statuses.filter(status => status.model.key === "facing-back");
				if (statuses.length > 0)
					statuses[0].dissipate();
				player.apply("intensity", player.getStatusValue("energetic"));
				src.master.notify("turnforward", player);
			}
			return [];
		}
		this.types = [];
	}
}